import { useHttpClient } from "../http-client";
import React from "react";
import { ApiResponse } from "../types/api-response";
import { useMutation } from "@tanstack/react-query";

export const useSkipResponseApi = () => {
  const httpClient = useHttpClient();

  const skip = React.useCallback(
    async (params: {
      organizationId: string;
      responseId: string;
      themeStructureId: string;
    }): Promise<ApiResponse> => {
      const response = await httpClient.patch(
        `/classifier/responses/${params.responseId}/skip`,
        {
          organization_id: params.organizationId,
          theme_structure_id: params.themeStructureId,
        }
      );

      return response.data.data;
    },
    []
  );

  return useMutation({
    mutationFn: skip,
  });
};
